import React from 'react';
import { FileCheck } from 'lucide-react';
import ServiceTemplate from './ServiceTemplate';

const NotarizationPage = () => {
  const serviceData = {
    icon: FileCheck,
    nameAr: 'دائرة التوثيق',
    nameEn: 'Notarization Department',
    taglineAr: 'خدمات التوثيق الرسمي والمحررات القانونية',
    taglineEn: 'Official notarization services and legal documents',
    
    descriptionAr: [
      'دائرة التوثيق في وازن متخصصة في تقديم خدمات التوثيق الرسمي لجميع أنواع المستندات والمحررات القانونية. نعمل وفق الأنظمة السعودية لضمان صحة وقانونية جميع الوثائق.',
      'نقدم خدمات توثيق شاملة تشمل الوكالات، العقود، الإقرارات، وجميع المحررات التي تتطلب التوثيق الرسمي، مع إمكانية التوثيق الرقمي عبر منصتنا الإلكترونية.'
    ],
    descriptionEn: [
      'Wazin\'s Notarization Department specializes in providing official notarization services for all types of documents and legal instruments. We work in accordance with Saudi regulations to ensure the validity and legality of all documents.',
      'We provide comprehensive notarization services including powers of attorney, contracts, declarations, and all instruments requiring official notarization, with digital notarization available through our electronic platform.'
    ],

    services: [
      {
        nameAr: 'إعداد وصياغة الوكالات الشرعية والوكالات الخاصة',
        nameEn: 'Preparing and drafting legal powers of attorney and special powers',
        descAr: 'صياغة جميع أنواع الوكالات الشرعية والخاصة حسب احتياج العميل وطبيعة التفويض المطلوب',
        descEn: 'Drafting all types of legal and special powers of attorney according to client needs and required authorization'
      },
      {
        nameAr: 'إعداد عقود التوثيق الرسمية (مثل عقود البيع والهبة ونقل الحصص)',
        nameEn: 'Preparing official notarization contracts (such as sale, gift, and share transfer)',
        descAr: 'إعداد وصياغة العقود التي تتطلب توثيقاً رسمياً لدى الجهات المختصة',
        descEn: 'Preparing and drafting contracts requiring official notarization with competent authorities'
      },
      {
        nameAr: 'توثيق الإقرارات والتعهدات الرسمية',
        nameEn: 'Notarizing official declarations and undertakings',
        descAr: 'إعداد وتوثيق الإقرارات والتعهدات القانونية لدى الجهات المختصة',
        descEn: 'Preparing and notarizing legal declarations and undertakings with competent authorities'
      },
      {
        nameAr: 'توثيق محاضر الاجتماعات والقرارات ذات الطابع الرسمي',
        nameEn: 'Notarizing meeting minutes and official decisions',
        descAr: 'توثيق محاضر اجتماعات الشركاء والمساهمين والقرارات الرسمية للشركات',
        descEn: 'Notarizing partners and shareholders meeting minutes and official company decisions'
      },
      {
        nameAr: 'توثيق عقود الشركات والتعديلات المرتبطة بها بالتنسيق مع الجهات المختصة',
        nameEn: 'Notarizing company contracts and related amendments with competent authorities',
        descAr: 'توثيق عقود تأسيس الشركات وتعديلاتها لدى وزارة التجارة والجهات ذات العلاقة',
        descEn: 'Notarizing company formation contracts and amendments with Ministry of Commerce and related entities'
      },
      {
        nameAr: 'متابعة وإنهاء إجراءات التوثيق لدى كتابات العدل والجهات الحكومية المختصة',
        nameEn: 'Following up and completing notarization procedures with notary offices and government entities',
        descAr: 'المتابعة الكاملة لجميع إجراءات التوثيق وإنهائها لدى الجهات الرسمية المختصة',
        descEn: 'Complete follow-up of all notarization procedures and completion with competent official authorities'
      }
    ],

    specializations: [
      { ar: 'وكالات البيع والشراء', en: 'Sale and Purchase Powers' },
      { ar: 'وكالات الإدارة', en: 'Management Powers' },
      { ar: 'توثيق عقود الزواج', en: 'Marriage Contract Notarization' },
      { ar: 'توثيق الوصايا', en: 'Will Notarization' },
      { ar: 'توثيق الإقرارات', en: 'Declaration Notarization' },
      { ar: 'توثيق العقود العقارية', en: 'Real Estate Contract Notarization' },
      { ar: 'توثيق عقود الشركات', en: 'Company Contract Notarization' },
      { ar: 'إلغاء الوكالات', en: 'Power of Attorney Revocation' },
      { ar: 'التوثيق للجهات الأجنبية', en: 'Notarization for Foreign Entities' },
      { ar: 'توثيق المستندات التجارية', en: 'Commercial Document Notarization' }
    ],

    faqs: [
      {
        questionAr: 'ما الفرق بين التوثيق والتصديق؟',
        questionEn: 'What is the difference between notarization and attestation?',
        answerAr: 'التوثيق هو إثبات صحة المستند وتوقيعاته من قبل جهة رسمية مختصة، بينما التصديق هو اعتماد الوثيقة من جهات عليا مثل وزارة الخارجية للاستخدام خارج المملكة.',
        answerEn: 'Notarization is proving the validity of the document and its signatures by a competent official authority, while attestation is certification of the document by higher authorities such as the Ministry of Foreign Affairs for use outside the Kingdom.'
      },
      {
        questionAr: 'هل يمكن التوثيق إلكترونياً؟',
        questionEn: 'Can notarization be done electronically?',
        answerAr: 'نعم، نوفر خدمة التوثيق الإلكتروني من خلال منصة ناجز وغيرها من المنصات الحكومية الرسمية، مما يوفر الوقت والجهد على عملائنا.',
        answerEn: 'Yes, we provide electronic notarization services through the Najiz platform and other official government platforms, saving time and effort for our clients.'
      },
      {
        questionAr: 'كم يستغرق توثيق الوكالة؟',
        questionEn: 'How long does it take to notarize a power of attorney?',
        answerAr: 'عادةً يتم توثيق الوكالة في نفس اليوم إذا كانت جميع المستندات المطلوبة جاهزة. قد تستغرق بعض الحالات الخاصة يومين إلى ثلاثة أيام عمل.',
        answerEn: 'Usually, power of attorney notarization is completed on the same day if all required documents are ready. Some special cases may take two to three business days.'
      },
      {
        questionAr: 'ما المستندات المطلوبة للتوثيق؟',
        questionEn: 'What documents are required for notarization?',
        answerAr: 'تختلف المستندات المطلوبة حسب نوع الوثيقة، لكن عموماً تشمل: الهوية الوطنية أو الإقامة للأطراف، المستند المراد توثيقه، وأي مستندات داعمة حسب الحالة.',
        answerEn: 'Required documents vary depending on the type of document, but generally include: national ID or residence permit for parties, document to be notarized, and any supporting documents as needed.'
      }
    ]
  };

  return <ServiceTemplate serviceData={serviceData} />;
};

export default NotarizationPage;